module.exports = __webpack_public_path__ + "static/drivex-1-8ca4c80d3108c8c10bf80f412a22d7b4.png";